import styled from '@emotion/styled';

import { ReactComponent as PauseIcon } from '@icons/pause.svg';
import { ReactComponent as PlayIcon } from '@icons/play.svg';
import { ifProp } from '@lib/ifProp';
import { buttonBase } from '@styles/mixins/button';

interface ButtonPlayProps
  extends React.DetailedHTMLProps<React.ButtonHTMLAttributes<HTMLButtonElement>, HTMLButtonElement> {
  isPlaying?: boolean;
  isVisible?: boolean;
}

export const ButtonPlay: React.FC<ButtonPlayProps> = ({ isPlaying, isVisible, className, onClick }) => {
  return (
    <Button
      className={className}
      aria-label={`video is ${isPlaying ? 'playing' : 'paused'} now`}
      onClick={onClick}
      isPlaying={isPlaying}
      isVisible={isVisible}
      disabled={!isVisible}
    >
      {isPlaying ? <PauseIcon role="presentation" /> : <PlayIcon role="presentation" />}
    </Button>
  );
};

interface ButtonProps {
  isPlaying?: boolean;
  isVisible?: boolean;
}

const Button = styled.button<ButtonProps>`
  ${buttonBase}
  width: 106px;
  height: 106px;
  padding-top: 25px;
  padding-right: 26px;
  padding-bottom: 26px;
  padding-left: ${ifProp('isPlaying', '26px', '36px')};
  opacity: ${ifProp('isVisible', '1', '0')};
  transition-property: opacity, transform, background-color;
`;
